import React from 'react';

/**
 * Formats a number with conditional red color for negative values
 * @param value - The number to format (or null/undefined)
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted number as string or JSX with red styling for negatives
 */
export function formatNumberWithColor(
  value: number | null | undefined,
  decimals: number = 2
): React.ReactNode {
  if (value === null || value === undefined) {
    return '—';
  }

  const formatted = Number(value).toFixed(decimals);

  if (value < 0) {
    return <span className="text-red-700">{formatted}</span>;
  }

  return formatted;
}

/**
 * Formats a number as an integer (rounded) with conditional red color for negative values
 * This function properly handles floating-point precision issues by rounding to the nearest integer
 * @param value - The number to format (or null/undefined)
 * @returns Formatted integer as string or JSX with red styling for negatives
 */
export function formatIntegerWithColor(
  value: number | null | undefined
): React.ReactNode {
  if (value === null || value === undefined) {
    return '—';
  }

  // Use Math.round to properly handle floating-point precision issues
  const rounded = Math.round(Number(value));
  const formatted = String(rounded);

  if (rounded < 0) {
    return <span className="text-red-700">{formatted}</span>;
  }

  return formatted;
}

